import supabase from "../../../shared/database/supabase";
import { ServiceOrderRepository } from "../../../models/service-order/service-order.repository";

export interface searchServiceOrdersRequest {
  search_term: string;
  page_limit?: number;
  page_offset?: number;
};

export interface SearchServiceOrder{
    service_order_id: string;
    finished: boolean;
    created_at: string;
    updated_at: string;
    finished_at: string | null;
    costumer_id: string;
    costumer_name: string;
    car_id: string | null;
    car_plate: string | null;
    car_model: string | null;
    car_chassis_number: string | null;
    service_order_line_count: number;
};

export interface searchServiceOrdersResponse {
  service_orders: SearchServiceOrder[];
  total: number;
};

export const searchServiceOrders = async (params: searchServiceOrdersRequest) => {
    try {
        const { data, error } = await supabase.functions.invoke<searchServiceOrdersResponse>("search-service-orders", {
            body: JSON.stringify({
                search_term: params.search_term,
                page_limit: params.page_limit ?? 20,
                page_offset: params.page_offset ?? 0,
            }),
        });
        console.log("search-service-orders response:", data, error);

        if (error) {
            console.error("Error calling search-service-orders:", error);
            return { data: null, error };
        }
        return { data , error: null };
    } catch (err) {
        console.error("Exception in searchServiceOrders:", err);
        throw err;
    }
};